module.exports = __webpack_public_path__ + "static/media/XXIIh.9ab36f41.png";